export const constants = {
    VIMEO_PLAYER_URL: 'https://player.vimeo.com/video',
    YOUTUBE_PLAYER_URL: 'https://www.youtube.com/embed',
};

export default constants;